import { Alert, Link, Text } from '@nimbus-ds/components';
import { useNavegate } from 'App/hooks';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

function InvoiceSettingsAlert() {
  const t = useTranslationCatalog('products.detail.invoiceSettings');
  const { goTo } = useNavegate();
  const handleClick = () => goTo('/settings/invoices/');

  return (
    <Alert appearance="primary" title={t('titleAlert')}>
      <Text>{t('contentAlert')}</Text>
      <Link onClick={handleClick}>{t('linkAlert')}</Link>
    </Alert>
  );
}

export default InvoiceSettingsAlert;
